import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

const ActionItem = ({ label, icon, action, disabled }) => {
    const handleClick = () => {
        action(); // Execute the passed action
    };

    return (
        <MenuItem onClick={handleClick} disabled={disabled}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{label}</ListItemText>
        </MenuItem>
    );
};

export default ActionItem;
